export default __webpack_public_path__ + "static/placeholder_page_logo-2598539ab173bc32fdb23baa4de53af4.jpg";